import * as types from '../types'
// state
let Sys = {}
let ua = navigator.userAgent.toLowerCase()
var s
(s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.browser = 'ie' :
(s = ua.match(/msie ([\d.]+)/)) ? Sys.browser = 'ie' :
(s = ua.match(/firefox\/([\d.]+)/)) ? Sys.browser = 'firefox' :
(s = ua.match(/chrome\/([\d.]+)/)) ? Sys.browser = 'chrome' :
(s = ua.match(/opera.([\d.]+)/)) ? Sys.browser = 'opera' :
(s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.browser = 'safari' : 0

const state = {
  isPhone: false,
  browser: Sys.browser
}

const mutations = {
  [types.AGENT](state, status) {
    state.isPhone = status
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userAgent.js